module.exports = __webpack_public_path__ + "rental-portfolios-1.2112658.png";